require('./index.scss')

import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'

import { translate } from '@/utils/translations'

import PaymentRegister from './PaymentRegister'

const CartOrderSummary = ({ children }) => {
  const storeCurrency = useSelector(state => state.currentRegion.storeCurrency)

  return (
    <div className='price-list'>
      <div className='clearfix'>
        <h2 className='styled_as_body_font'>
          {translate('carts.order_summary')}
        </h2>
        <span className='u-float--right styled_as_body_font u-weight--bold'>
          {storeCurrency}
        </span>
      </div>
      <hr aria-hidden='true' />
      {children}
      <PaymentRegister />
    </div>
  )
}

CartOrderSummary.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ])
}

export default CartOrderSummary
